var filtersModule =  angular.module('filters',[]);
export default filtersModule.name;